module.exports = __webpack_public_path__ + "static/media/10.33c68db5.mp3";